<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'金融合作伙伴管理'},{name:'会员单位管理'}]" :title="'会员单位管理'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <div class="child">
                        <span class="name">入会时间</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <el-button type="primary" size="small" @click="onSearch" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
                <div class="right">
                   
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="name"
                    show-overflow-tooltip
                    >
                    <template slot-scope="scope">
                        <div class="elrow">
                            <i class="el-icon-top" v-if="scope.$index != 0 || (scope.$index === 0 && currentPage  !== 1)" @click="moveDown(scope.row,0)"></i>
                            <i class="el-icon-bottom" v-if="scope.$index != tableData.length - 1 || currentPage < totalPage" @click="moveDown(scope.row,1)"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    type="index"
                    show-overflow-tooltip
                    label="序号">
                </el-table-column>
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    label="会员单位ID">
                </el-table-column>
                <el-table-column
                    prop="account"
                    show-overflow-tooltip
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="companyName"
                    show-overflow-tooltip
                    label="单位名称">
                </el-table-column>
                <el-table-column
                    prop="industryName"
                    show-overflow-tooltip
                    label="行业">
                </el-table-column>
                <el-table-column
                    prop="userName"
                    show-overflow-tooltip
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="phone"
                    show-overflow-tooltip
                    label="联系方式">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    sortable="custom"
                    label="入会时间">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="250">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="edit(scope.row)">编辑</el-button>
                        <el-button :class="{'noclick':scope.row.isEditable==1}" size="small" type="primary"  class="super" plain
                                    @click="onUp(scope.row)" >上传LOGO</el-button>
                         <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
           <el-dialog
            title="上传LOGO"
            :visible.sync="dialogVisible"
            custom-class="super_logo"
            width="32%" >
            <el-form :model="logoForm" :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="上传LOGO：" prop="logoUrl">
                    <upLoad
						:action="'backstage/annex/file'"
						:accept="'image/png,image/jpg,image/jpeg'" 
						:size="5"
            is-need-limit
            :sizeList="[1 / 1]"
            :fixedNumber='[1,1]'
            :autoCropWidth="80"
            :autoCropHeight='80'
            :base="base"
						v-model="logoForm.logoUrl" tip="*png、jpg等常规格式图片，大小不超过5M，建议尺寸为80*80"/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="onClose">取 消</el-button>
              <el-button size="small" type="primary" @click="onSub">确 定</el-button>
            </span>
          </el-dialog>
            
        </div>
</template>

<script>

// import breadcrumb from '../../components/breadcrumb';
import {API} from "@/axios/config";
import {getDict} from "@/axios";
import timeMixins from "@/mixins/timeFormat";
import upLoad from '../../components/upLoadAvatar'
export default {
    mixins:[timeMixins],
    components:{
      upLoad
        // breadcrumb
    },
    data(){
        return{
          baseUrl:API.UploadsService,//服务器
          dialogVisible:false,
            loading:false,
            bHeight: void 0,
            ishide:false,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '1',
                label: '申请ID'
            },{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
            }],//检索下拉
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                applyAccount: 1, // 账号
                 startTime:void 0,
                endTime: void 0,
                id: void 0, //  申请ID
                userName: void 0
            },//检索提交数据
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            dialogAudit:false,//更新进度弹出层
            sendInfoTwo:{
                applyId:'',//id
                rate:'',//担保进度
                amount:'',//是否已放款选择值
                dealWithRemark:'',//说明
            },
            isSelect:'1',
            totalSize:null,
            statusList:[],
            scopeList:[],
            detailInfo:{
                applicant:"",
                contactPhone:"",
                applyCompany:"",
                applyRemark:"",
                fileList:[],
                createTime:"",
                amount:"",
                checkExplanation:"",
                modifyUserName:"",
                updateTime:""
            },
             move:{
                id:'',
                move:''
            },
            logoForm:{
                id:void 0,// ，编辑时必传
                companyName: void 0, // 公司名称
                industry: void 0, // 行业id
                logoUrl: void 0,// logo地址
                phone: void 0,// 电话
                userName: void 0, // 申请人姓名
            },
            base: void 0,
            totalPage:0,
            rules:{
              logoUrl:[
                { required: true, message: '请上传LOGO'}
              ]
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfoTwo.rate':{
            test:function(){
                if(this.sendInfoTwo.rate){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择担保进度'
        },
        'isSelect':{
            test:function(){
                if(this.isSelect){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择是否已放款'
        },
        'sendInfoTwo.amount':{
            test:function(){
                if(this.isSelect == 1){
                    return true
                }else{
                    if(this.sendInfoTwo.amount){
                        return true;
                    }else{
                        return false;
                    }
                }
                
            },
            message:'输入放款金额'
        },
    },
    methods:{
      onClose(){
        this.upLoading = false
        this.dialogVisible = false
      },
      async onSub(){
        const that = this
        if(!that.logoForm.logoUrl){
          that.$message.info('请上传LOGO')
          return 
        }
        const {code ,msg} = await that.$axioscBody.post('/backstage/vipUnit/saveVipUnit',that.logoForm)
        if(code === 200) {
          that.logoForm={
                id:void 0,// ，编辑时必传
                companyName: void 0, // 公司名称
                industry: void 0, // 行业id
                logoUrl: void 0,// logo地址
                phone: void 0,// 电话
                userName: void 0, // 申请人姓名
          }
          that.dialogVisible = false
          that.$message.success('保存成功')
          that.getData()
        }else{
          that.$message.info(msg ||'保存失败')
        }
      },
      
      //排序
        moveDown:function(row,val){
            this.move.id = row.id
            this.move.move = val
            this.$axiosc.put('/backstage/vipUnit/moveUpDown',this.$qs.stringify(this.move)).then(res=>{
                if(res.code == 200){
                    this.getData()
                    this.$message({
                        type: 'success',
                        message: val == 0?'上移成功':'下移成功'
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
            })
        },
      //发布 编辑
        edit:function(row){
            if(row){//编辑
                this.$router.push({path:`/partnerManagement/memberUnit/edit/${row.id}`,query:{index:'/partnerManagement/memberUnit'},params:{id:row.id}})
            }else{//发布
                this.$router.push({path:'/partnerManagement/memberUnit/edit',query:{index:'/partnerManagement/memberUnit'}})
            }
        },
      onUp(row){
        this.dialogVisible = true
        const param = {
                id:row.id,// ，编辑时必传
                companyName: row.companyName, // 公司名称
                industry: row.industry, // 行业id
                logoUrl: row.logoUrl,// logo地址
                phone: row.phone,// 电话
                userName: row.userName, // 申请人姓名
        }
        this.base = row.frontPath
        this.logoForm = Object.assign(this.logoForm,param)
      },
      onReset(){
            const param= {
              currentPage:1,//当前页
                pageSize:10,//页条数
                applyAccount: 1, // 账号
                startTime:void 0,
                endTime: void 0,
                id: void 0, //  申请ID
                userName: void 0
            }
            this.sendInfoOne = Object.assign(this.sendInfoOne,param)
            this.dateS = void 0
            this.getSelect = void 0
            this.getValue = void 0
            this.onSearch()
      },
      onSearch(){
        let lookData=this.dateS;
			if(lookData&&lookData.length>0){
				this.sendInfoOne.startTime=lookData[0];
				this.sendInfoOne.endTime=lookData[1];
			}else {
          this.sendInfoOne.startTime=null;
          this.sendInfoOne.endTime=null;
      }
			// 检索值
			let lookdell= parseInt(this.getSelect);
			this.sendInfoOne.id= void 0;
			this.sendInfoOne.applyAccount= void 0;
			this.sendInfoOne.userName= void 0;
      // this.sendInfo.checkType = this.checkType
			if(lookdell==1){
				this.sendInfoOne.id=this.getValue;
			}else if(lookdell==2){
				this.sendInfoOne.applyAccount=this.getValue;
			}else{
        this.sendInfoOne.userName=this.getValue;
      }
      this.getData()
      },
       doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='ASC';
            }else{
                order='DESC';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //表格查看按钮
        check:function(row){
            if(row.vouchName == '经开区中小担'){
                this.ishide = true
            }else{
                this.ishide = false
            }
            // this.$axiosc.get('backstage/vouch/apply/details/'+row.id).then(res=>{
            //     if(res.code == 200){
            //         this.detailInfo = res.data
            //          this.dialogInfo=true;
            //     }else{
            //         this.$message({
            //             type: 'error',
            //             message: res.msg
            //         });
            //     }
            // })
            this.$router.push({path: `/partnerManagement/memberUnit/detail/${row.id}`, query: {index: '/partnerManagement/memberUnit',ishide:this.ishide},param:{id:row.id}})
        },
        //表格更新进度
        updateProgress:function(row){
            this.sendInfoTwo.applyId = row.id
            this.sendInfoTwo.rate = ''//担保进度
            this.sendInfoTwo.amount=''//是否已放款选择值
            this.sendInfoTwo.dealWithRemark=''//说明
            this.dialogAudit=true;
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axiosc.put('backstage/vouch/update/progress',this.$qs.stringify(this.sendInfoTwo)).then(res=>{
                    if(res.code == 200){
                        this.getData()
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.dialogAudit=false
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        getData(){
            this.loading = true
            this.$axiosc.get('/backstage/vipUnit/findVipUnitList',{params:this.sendInfoOne}).then(res=>{
                this.loading = false
                if(res.code==200){
                    this.tableData=res.data.content;
                    this.totalSize=res.data.totalElements;
                    this.currentPage = res.data.currentPage; //当前页
                    this.totalPage = res.data.totalPage
                }else{
                    this.$alert(res.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        }
    },

    mounted(){
        const that = this
        // getDict('isShow/VOUCH_RATE').then(data=>{
        //     that.statusList = data['isShow/VOUCH_RATE']
        // })
         // 请求
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>
.forms .child .el-input{
  max-width:100% !important;
}  
</style>